import { PropsWithChildren, memo } from 'react'
import { Provider } from 'react-redux'
import { store } from 'redux/store'

interface ReduxProviderProps {}
export const ReduxProvider: React.FC<PropsWithChildren<ReduxProviderProps>> = memo(({ children }) => {
    return <Provider store={store}>{children}</Provider>
})
ReduxProvider.displayName = 'ReduxProvider'
